/* WDS sticky ATC — shows the bar once the buy box's submit button scrolls
   above the viewport, hides it again when it returns. */
(function () {
  class WdsStickyAtc extends HTMLElement {
    connectedCallback() {
      const target =
        document.getElementById('ProductSubmitButton-' + this.dataset.sectionId) ||
        document.getElementById(this.dataset.formId);
      if (!target || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const passedAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('wds-sticky-atc--show', passedAbove);
            this.setAttribute('aria-hidden', passedAbove ? 'false' : 'true');
          });
        },
        { threshold: 0 }
      );
      this.observer.observe(target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('wds-sticky-atc')) {
    customElements.define('wds-sticky-atc', WdsStickyAtc);
  }
})();
